import { render, staticRenderFns } from "./DeslindesTabla.vue?vue&type=template&id=518f2597&scoped=true&"
import script from "./DeslindesTabla.vue?vue&type=script&lang=js&"
export * from "./DeslindesTabla.vue?vue&type=script&lang=js&"
import style0 from "./DeslindesTabla.vue?vue&type=style&index=0&id=518f2597&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f2597",
  null
  
)

export default component.exports